var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcLock2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.75 5.5H11.125V4.25C11.125 2.525 9.725 1.125 8 1.125C6.275 1.125 4.875 2.525 4.875 4.25V5.5H4.25C3.5625 5.5 3 6.0625 3 6.75V13C3 13.6875 3.5625 14.25 4.25 14.25H11.75C12.4375 14.25 13 13.6875 13 13V6.75C13 6.0625 12.4375 5.5 11.75 5.5ZM8 11.125C7.3125 11.125 6.75 10.5625 6.75 9.875C6.75 9.1875 7.3125 8.625 8 8.625C8.6875 8.625 9.25 9.1875 9.25 9.875C9.25 10.5625 8.6875 11.125 8 11.125ZM6.125 5.5V4.25C6.125 3.2125 6.9625 2.375 8 2.375C9.0375 2.375 9.875 3.2125 9.875 4.25V5.5H6.125Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcLock2);
export default __webpack_public_path__ + "static/media/ic-lock-2.2b6bef945af83afa3445b46598d3acca.svg";
export { ForwardRef as ReactComponent };